.<template>
  <footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="footer__content">
            <router-link to="/" class="footer__logo">
              <img src="static/Image/logo.svg" alt="" />
            </router-link>
            <span class="footer__copyright"
              >© MicroFlix, 2022-2025 <br />
            </span>
            <button
              class="footer__back"
              @click="GoTop"
              v-show="isShow"
              type="button"
            >
              <i class="icon ion-ios-arrow-round-up"></i>
            </button>
          </div>
        </div>
      </div>
      <ul v-if="true" style="margin-top: 20px" class="footer-links structural">
        <li v-show="!isPay" class="footer-link-item">
          <a @click="goto('/FAQ')" class="footer-link"
            ><span id="" data-uia="data-uia-footer-label">FAQ</span></a
          >
        </li>
        <li v-show="!isPay" class="footer-link-item originals-link">
          <a @click="goto('/HelpCenter')" class="footer-link"
            ><span id="" data-uia="data-uia-footer-label">Help Center</span></a
          >
        </li>
        <li class="footer-link-item">
          <a @click="goto('/termsofuse')" class="footer-link"
            ><span id="" data-uia="data-uia-footer-label">Terms of Use</span></a
          >
        </li>
        <li class="footer-link-item originals-link">
          <a @click="goto('/privacy')" class="footer-link"
            ><span id="" data-uia="data-uia-footer-label">Privacy</span></a
          >
        </li>
        <li v-show="!isPay" class="footer-link-item">
          <a @click="goto('/Contactus')" class="footer-link"
            ><span id="" data-uia="data-uia-footer-label">Contact Us</span></a
          >
        </li>
        <li v-show="!isPay" class="footer-link-item">
          <a @click="goto('/CorporateInformation')" class="footer-link"
            ><span id="" data-uia="data-uia-footer-label"
              >Corporate Information</span
            ></a
          >
        </li>
        <li v-show="!isPay" class="footer-link-item">
          <a @click="goto('/CookiePreferences')" class="footer-link"
            ><span id="" data-uia="data-uia-footer-label"
              >Cookie Preferences</span
            ></a
          >
        </li>
        <li v-show="!isPay" class="footer-link-item originals-link">
          <a @click="goto('/LegalNotices')" class="footer-link disable"
            ><span id="" data-uia="data-uia-footer-label"
              >Legal Notices</span
            ></a
          >
        </li>
      </ul>
    </div>
  </footer>
</template>

<script>
export default {
  props: ["isPay"],
  data() {
    return {
      isShow: false,
    };
  },
  mounted() {
    var That = this;
    window.onscroll = function () {
      That.isShow = That.reversedMessage();
    };
  },
  methods: {
    GoTop() {
      document.documentElement.scrollTop = 0;
    },
    goto(path) {
      this.$bus.$emit("ShowPay", "0", "");
      this.$router.push({
        path: path,
      });
    },
    reversedMessage() {
      var heightTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      var bodyisOver = document.body.style.overflow === "hidden";
      if (!bodyisOver && heightTop > 20) {
        return true;
      }
      return false;
    },
  },
};
</script>

.<style scoped>
.footer-links {
  max-width: 1310px;
  font-size: 16px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
ul.structural {
  padding: 0;
  margin: 0 auto;
}
.footer-link:hover {
  color: #f9ab00 !important;
  text-decoration: underline;
}
.footer-link {
  text-decoration: none;
}
.footer-link span {
  letter-spacing: 0px;
}
ul > li {
  margin-left: 1.1em;
  margin-bottom: 5px;
  list-style-type: disc;
  text-align: center;
}
ul > li > a {
  color: var(--Foot-white) !important;
  font-size: 14px;
  cursor: pointer;
}

@media (max-width: 740px) {
  .footer-link-item {
    width: 33%;
  }
}
.footer-link-item {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0;
  margin-bottom: 10px;
  display: inline-block;
  /* min-width: 100px; */
  width: 33%;
  padding-right: 12px;
  vertical-align: top;
}
/* .footer-link-item:nth-child(odd){
  background-color: red;
} */
@media (max-width: 500px) {
  .footer-link-item {
    width: 49%;
  }
}

@media (max-width: 740px) {
  .footer-link-item {
    width: 49%;
  }
}
@media (min-width: 1200px) {
  .footer-link-item {
    width: 24%;
  }
}
a[disable] {
  pointer-events: none;
}
ul.structural > li {
  list-style: none;
  text-align: left;
  margin-left: 0;
  height: 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/Foot.vue